/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated do not edit it manually",
 */
import React from "react";

import { minusBold } from "../assets/minus-bold";
import { Icon, type IconBaseProps } from "../icon";

export const IconMinusBold = (props: IconBaseProps) => <Icon {...props} svg={minusBold} />;

IconMinusBold.displayName = "IconMinusBold";
